import Cookies from 'js-cookie'
import _ from 'lodash'
import utils from '@/assets/scripts/utilities.js'
import { SIGN_IN, SIGN_OUT, SET_USER_DATA } from '../mutation-types'
import { ENTER_SITE, EXIT_SITE } from '../action-types'

const INVESTOR_DATA_TASK_NAME = 'viewInvestorDocsAndData'

const user = {
  namespaced: true,
  state: () => ({
    isAuthenticated: false,
    current: null,
    tokenExpirationMins: 0,
    sessionExpirationMins: 0,
  }),
  mutations: {
    [SIGN_IN](state) {
      state.isAuthenticated = true
      // Read Session related settings from a cookie.
      // Settings are stored in the DB
      const cookieId = utils.getCookieId()
      let sessionInfoCookie = Cookies.get(`gts_exp_info_${cookieId}`)
      if (sessionInfoCookie) {
        let arySessInfo = sessionInfoCookie.split('|')
        let tokenExpFromCookie = arySessInfo[0]
        let sessExpFromCookie = arySessInfo[1]
        state.tokenExpirationMins = utils.parseInt(tokenExpFromCookie)
        state.sessionExpirationMins = utils.parseInt(sessExpFromCookie)
      }
    },
    [SIGN_OUT](state, redirectURL) {
      $.ajax({
        url: `${AUTH_URL}/account/logout`,
        method: 'PUT',
        async: false,
      }).done(function () {
        state.isAuthenticated = false
        $(window).off('beforeunload')
        window.location.href = redirectURL || '/'
        // Trick that can help timing issues with data binding
        // Update: Not observed - commented out till further notice
        // setTimeout(() => {
        //   window.location.href = redirectURL || '/'
        // }, 0)
      })
    },
    [SET_USER_DATA](state, json) {
      state.current = json
      // TODO
      // state.current.isAccessCodeUser = true
      // state.current.accessCodeFI = 'FIDEL'
    },
  },
  actions: {
    [ENTER_SITE]({ commit }, payload) {
      commit(SET_USER_DATA, payload)
      commit(SIGN_IN)
    },
    [EXIT_SITE]({ commit }, payload) {
      commit(SIGN_OUT, payload)
    },
  },
  getters: {
    currentUser(state) {
      return state.current
    },
    tasks(state) {
      return state.current?.tasks
    },
    hasInvestorPermissions(state) {
      let hasPermissions = _.includes(
        _.map(state.current?.tasks.Features, (o) => o.name),
        INVESTOR_DATA_TASK_NAME,
      )

      return hasPermissions
    },
    getTokenExpirationMsecs(state) {
      return state.tokenExpirationMins * 60 * 1000
    },
    getSessionExpirationMsecs(state) {
      return state.sessionExpirationMins * 60 * 1000
    },
    getPermissionsPerCategoryAndRoute:
      (state) =>
      ({ category, route }) => {
        let _task = state.current?.tasks[category].filter(
          (t) => t.route === route,
        )[0]

        let _permissions = {}

        for (const p in state.current?.permissions) {
          if (Object.hasOwnProperty.call(state.current?.permissions, p)) {
            const permission = state.current?.permissions[p]

            if (p.startsWith(_task?.name)) {
              _permissions[p.slice(_task?.name.length)] = permission
            }
          }
        }

        return _permissions
      },
  },
}

export default user
